import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ResetPasswordService {
  private baseUrl: string = environment.baseUrlResetPass;

  constructor(private http: HttpClient) { }

  resetPassword(userId: number, newPassword: string,token:string): Observable<any> {
    console.log(this.baseUrl)
    const url = `${this.baseUrl}user/${userId}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}` // Include the token in the Authorization header
    });
    const payload = { password: newPassword };

    return this.http.put(url, payload, { headers }).pipe(
      catchError(this.handleError)
    );
  }

  private handleError(error: any): Observable<never> {
    console.error('An error occurred', error);
    return throwError(error.message || error);
  }
}
